<div class="padding-small bg-light-grey padding-left-large small">
	<div class="flex center">Photographers</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Photographers</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!photographerFilters.textSearch ? '' : 'selected'">
			@if (photographerFilters.textSearch) {
				<div class="flex center hover" (click)="openNameFilter()">
					<b class="margin-right-smallest">Name or surname:</b>
					{{ photographerFilters.textSearch }}
				</div>

				<mat-icon class="hover" (click)="cleanFilter('textSearch')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openNameFilter()">
					Name or surname
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.brands || !photographerFilters.brands.length ? '' : 'selected'">
			@if (photographerFilters.brands && photographerFilters.brands.length) {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					<b class="margin-right-smallest">Brand:</b>

					@for (brand of photographerFilters.brands; track brand; let last = $last) {
						{{ brand.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					Brand
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.contractDate ? '' : 'selected'">
			@if (photographerFilters.contractDate) {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					<b class="margin-right-smallest">Contract Date:</b>

					{{ photographerFilters.contractDate.from | date: 'dd-MM-yyyy' }} - {{ photographerFilters.contractDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('contractDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					Contract Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.statuses || !photographerFilters.statuses.length ? '' : 'selected'">
			@if (photographerFilters.statuses && photographerFilters.statuses.length) {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					<b class="margin-right-smallest">Status:</b>

					@for (status of photographerFilters.statuses; track status; let last = $last) {
						{{ status.name }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					Status
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div>

	<div class="margin-top-small">
		<div class="flex column end margin-bottom-small">
			<!-- <button [routerLink]="['/company/photographer-detail', 'new']" class="flex center">
				<mat-icon>add</mat-icon>
				Add photographer
			</button> -->
		</div>

		@if (photographers && photographers.items && photographers.items.length) {
			<bt-paginator [pageNumber]="photographers.currentPage" [pageSize]="photographers.size" [totalNumber]="photographers.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

			<table class="desktop-only">
				<tr>
					<th>Id</th>
					<th>Name</th>
					<th>Surname</th>
					<th>Start date</th>
					<th>End date</th>
					<th>Brands</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
				@for (item of photographers.items; track item) {
					<tr>
						<td>
							{{ item.id }}
						</td>
						<td>
							{{ item.firstName }}
						</td>
						<td>
							{{ item.lastName }}
						</td>

						<td>
							{{ item.contractStartDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.contractEndDate | date: 'dd-MM-yyyy' }}
						</td>

						<td>
							@for (brand of item.brands; track brand; let last = $last) {
								{{ brand.name }}
								@if (!last) {
									,
								}
							}
						</td>

						<td>
							@if (item.status?.id == photographerStatus.ACTIVE) {
								<span class="radius bg-green white padding-right-smallest padding-left-smallest">Active</span>
							} @else if (item.status?.id == photographerStatus.ON_TRIAL) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">On trial</span>
							} @else if (item.status?.id == photographerStatus.NOT_ACTIVE) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Not active</span>
							} @else if (item.status?.id == photographerStatus.DISMISSED) {
								<span class="radius bg-orange grey padding-right-smallest padding-left-smallest">Dismissed</span>
							}
						</td>
						<td>
							<div class="flex center full-width">
								<a [routerLink]="['/company/photographer-detail', item.id]" class="hover flex center primary margin-right">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</a>

								<span class="primary hover" (click)="goToPhotographerOrders(item.id)">
									<mat-icon class="small">assignment</mat-icon>
									View orders
								</span>

								<span class="margin-left-small hover flex center red" (click)="removePhotographer(item)">
									<mat-icon class="small">close</mat-icon>
									Remove
								</span>
							</div>
						</td>
					</tr>
				}
			</table>

			<bt-paginator [pageNumber]="photographers.currentPage" [pageSize]="photographers.size" [totalNumber]="photographers.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
		}

		@if (photographers.items.length == 0 && !loading) {
			<div class="flex center bg-light-grey padding-largest justify-center">
				<div class="flex column center gap">
					<i class="fa fa-search fa-2xl margin-bottom grey"></i>
					<span>No data found</span>
				</div>
			</div>
		}
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
